import { render } from "./AppPagination.vue?vue&type=template&id=6e76023d&scoped=true"
import script from "./AppPagination.vue?vue&type=script&lang=js"
export * from "./AppPagination.vue?vue&type=script&lang=js"

import "./AppPagination.vue?vue&type=style&index=0&id=6e76023d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e76023d"]])

export default __exports__